import { createAction, props } from "@ngrx/store";

export const store = createAction("[TaskNote] store", props<{ taskId: string; notes: string }>());

export const remove = createAction("[TaskNote] remove", props<{ taskId: string }>());
